<h2 mat-dialog-title>{{'contract_share_partner.manage_share_with_partners' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>

<div class="my-3">
    <app-share-partner-picker [selectedPartners]="SELECTED_PARTNERS"
        (selectedPartnersChange)="onSelectedPartnersChange($event)"></app-share-partner-picker>
</div>

<mat-dialog-actions align="center" class="mt-2" class="action">

    <button mat-stroked-button color="primary" (click)="close()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>

    <button mat-raised-button color="primary" class="ml-3" (click)="save()" type="button"
            [disabled] = "!isChange">
      <mat-icon class="mr-0">done_all</mat-icon>
      {{'button.save' | translate}}
    </button>
  </mat-dialog-actions>
